import React, { useState } from 'react';
import { api } from '../../utils';
import { CreateTenantModalProps, CreateTenantFormikType } from './model';
import Button from '../../CommonComponents/Button';
import { InputV2 } from '../../CommonComponents/InputV2/InputV2';
// import { SUPER_ADMIN_APIS, InstanceAdminApis } from '../../Services/Api';
import './CreateTenantModal.scss';
import Modal from '../../CommonComponents/Modal';
import { Formik } from 'formik';
import PhotoPlaceholderIcon from '../../assets/icons/photo_placeholder.svg';
import { FormErrorMessages, FormRegex } from '../../constants';
import * as Yup from 'yup';

const CreateTenantModal = (props: CreateTenantModalProps) => {
  const [processing, setProcessing] = useState<boolean>(false);
  function handleFormikSubmit(values: CreateTenantFormikType) {
    // setProcessing(true);
    // return fetch(`${window.BASE_URL}/rest/createadmins`, {
    //   method: 'POST',
    //   body: JSON.stringify(obj),
    //   credentials: 'include',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // }).then(handler);
    // SUPER_ADMIN_APIS.createAdmins(values.apiReqData).then((data) => {
    //   if (data.response === 'Success') {
    //     setProcessing(false);
    //     props.onCreate('Tenant Created');
    //   }
    // });
  }

  function updateProfile(tenantName: string, imageURL: string, tenantID: number) {
    setProcessing(true);
    api('updateTenantProfile', 'POST', {
      tenantName: tenantName,
      imageURL: imageURL,
      tenantId: tenantID,
    }).then((data) => {
      if (data.status === 'Success') {
        setProcessing(false);
        props.onCreate('Tenant Updated');
      }
    });
    // InstanceAdminApis.updateTenantProfile(tenantName, imageURL, tenantID).then((data) => {
    //   if (data.status === 'Success') {
    //     setProcessing(false);
    //     props.onCreate('Tenant Updated');
    //   }
    // });
  }
  return (
    <Modal
      title='Tenant profile' // newly added
      isOpen={true} //newly added
      onClose={props.onClose}
      // disableCloseButton={processing}
    >
      <Formik
        initialValues={{
          apiReqData: {
            admins: [],
            clientName: props.isUpdatingProfile
              ? (props.tenantInfo && props.tenantInfo.tenantName) || ''
              : '',
            imageURL: props.isUpdatingProfile
              ? (props.tenantInfo && props.tenantInfo.imageURL) || ''
              : '',
            tenantID: props.isUpdatingProfile
              ? (props.tenantInfo && props.tenantInfo.tenantId) || 0
              : 0,
          },
        }}
        onSubmit={handleFormikSubmit}
        render={({ values, setFieldValue, handleSubmit }) => {
          return (
            <div className='create-tenant-modal-body-w'>
              {/* {props.isUpdatingProfile ? (
                <div className='update-tenant'>Tenant profile</div>
              ) : (
                <div className='create-tenant'>
                  <div>Create Tenant</div>
                  <div>
                    <div>Set up the tenant profile</div>
                  </div>
                </div>
              )} */}
              <TenantProfile
                setFieldValue={setFieldValue}
                clientName={values.apiReqData.clientName}
                imageURL={values.apiReqData.imageURL}
                onClose={props.onClose}
                isUpdatingProfile={props.isUpdatingProfile}
                processing={processing}
                updateProfile={() =>
                  updateProfile(
                    values.apiReqData.clientName,
                    values.apiReqData.imageURL,
                    values.apiReqData.tenantID
                  )
                }
                existingTenantNames={props.existingTenantNames}
                submitForm={handleSubmit}
              />
            </div>
          );
        }}
      />
    </Modal>
  );
};

export default CreateTenantModal;

function TenantProfile(props: {
  submitForm: Function;
  setFieldValue: Function;
  imageURL: string;
  clientName: string;
  onClose: Function;
  isUpdatingProfile?: boolean;
  processing?: boolean;
  updateProfile: () => void;
  existingTenantNames: string[];
}) {
  const [isInvalidImageUrl, setIsInvalidImageUrl] = React.useState<boolean>(false);

  const originalClientName = React.useMemo(() => props.clientName.toLowerCase(), []);
  const schema = Yup.string()
    .required(FormErrorMessages.tenant.required)
    .matches(new RegExp(FormRegex.tenant), FormErrorMessages.tenant.inValid)
    .notOneOf(
      props.isUpdatingProfile
        ? props.existingTenantNames
            .map((f) => f.toLowerCase())
            .filter((f) => f !== originalClientName)
        : props.existingTenantNames.map((f) => f.toLowerCase()),
      FormErrorMessages.tenant.alreadyAdded
    );

  let errors: {
    tenantName: string;
  } = { tenantName: '' };

  try {
    schema.validateSync(props.clientName.toLowerCase());
  } catch (err) {
    errors.tenantName = err.message;
  }

  return (
    <div className='tenant-profile-w'>
      <div>
        <div>
          <img
            src={props.imageURL || PhotoPlaceholderIcon}
            style={{
              width: '44px',
              height: '44px',
              objectFit: 'cover',
              borderRadius: '4px',
            }}
            onError={() => setIsInvalidImageUrl(true)}
            onLoad={() => setIsInvalidImageUrl(false)}
          />
        </div>
        <InputV2
          placeholder='Profile Image URL'
          title='Profile Image URL'
          value={props.imageURL.trim()}
          onChange={(val) => props.setFieldValue('apiReqData.imageURL', val)}
          styles={{ marginBottom: '34px' }}
          id='profileImage'
          validationFailureMessage={
            isInvalidImageUrl ? FormErrorMessages.image.notFound : ''
          }
        />
        <InputV2
          placeholder='Tenant name'
          title='Tenant name'
          value={props.clientName}
          onChange={(val: string) => props.setFieldValue('apiReqData.clientName', val)} //newly added type string for val
          styles={{ marginBottom: '30px' }}
          required={true}
          id='tenantName'
          validationFailureMessage={errors.tenantName}
        />
      </div>
      <div className='create-tenant-modal-footer'>
        <div>
          {/* <Button
            title='Cancel'
            theme='3'
            onClick={props.onClose}
            disabled={props.processing}
          /> */}
          {/* commented as of now */}
          {/* <Button
            title={
              props.processing ? 'Saving...' : props.isUpdatingProfile ? 'Done' : 'Create'
            }
            // theme={props.isUpdatingProfile ? '4' : '0'}
            theme={props.isUpdatingProfile ? 'light' : 'dark'}
            // disabled={errors.tenantName || props.processing}
            onClick={() =>
              props.isUpdatingProfile ? props.updateProfile() : props.submitForm()
            }
          /> */}
          <Button
            text='Cancel'
            onClick={props.onClose}
            theme='secondary-blue'
            disabled={props.processing}
          />
          <Button
            disabled={(errors.tenantName ? true : false) || props.processing}
            text={
              props.processing ? 'Saving...' : props.isUpdatingProfile ? 'Done' : 'Create'
            }
            onClick={() =>
              props.isUpdatingProfile ? props.updateProfile() : props.submitForm()
            }
            theme='dark'
          />
        </div>
      </div>
    </div>
  );
}
